
export async function getQrImageForCode(code) {
    // encode your URL
    const url = encodeURIComponent(`https://k.laweka.se/?c=${code}`);
    const size = "300x300";
    // This returns an image (PNG) -> you can treat it as src of <img>
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}&data=${url}`;
}
